import { string } from 'prop-types'
import Cookies from 'js-cookie'
import React from 'react'

class BackToProjects extends React.PureComponent {
  handleClick = () => {
    Cookies.set('pathnameSearch', this.props.pathnameSearch)
  }
  render() {
    return (
      <div className="back-to-projects">
        <a
          href={`/projects${this.props.pathnameSearch}`}
          onClick={this.handleClick}
        >
          Back to Projects
        </a>
      </div>
    )
  }
}
BackToProjects.propTypes = {
  pathnameSearch: string.isRequired,
}

export default BackToProjects
